import React from 'react';
import PartnersHero from './sections/PartnersHero';
import PartnershipAnnouncements from './sections/PartnershipAnnouncements';
import PartnersCTA from './sections/PartnersCTA';

const PartnersPage = () => {
  return (
    <main className="min-h-screen bg-black">
      <PartnersHero />
      <PartnershipAnnouncements />
      <PartnersCTA />
    </main>
  );
};

export default PartnersPage;